// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.breadcrumbs-dropdown {
  min-width: 9.375rem;
  max-width: 17.5rem;
  padding-top: calc(.75rem);
  padding-bottom: calc(.75rem);
  background: white;
  box-shadow: 0 0 4px rgb(0, 0, 0, 0.1);
}

.breadcrumbs-dropdown__list {
    padding: 0;
    margin: 0;
    list-style: none;
  }

.breadcrumbs-dropdown__item {
    display: flex;
    flex-direction: row;
    gap: calc(.25rem);
    padding-top: calc(.25rem);
    padding-right: 1rem;
    padding-bottom: calc(.25rem);
    padding-left: 1rem;
  }

.breadcrumbs-dropdown__icon {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: auto;
  }

.breadcrumbs-dropdown__link {
    display: flex;
    flex-grow: 1;
    flex-shrink: 2;
    flex-basis: auto;
    color: #707070;
    -webkit-text-decoration: none;
    text-decoration: none;
  }

.breadcrumbs-dropdown__link:hover {
      -webkit-text-decoration: underline;
      text-decoration: underline;
    }

.breadcrumbs {
  display: flex;
  align-items: center;
  padding: 0;
  margin: 0;
  list-style: none;
}

.breadcrumbs__item,
  .breadcrumbs__item--current {
    font-size: 0.875rem;
    font-weight: 400;
    color: #707070;
  }

.breadcrumbs__item--current {
    display: -webkit-box;
    height: 1lh;
    max-height: 1lh;
    overflow: hidden;
    -webkit-line-clamp: 1;
    font-weight: 600;
    line-height: 1.375rem;
    -webkit-box-orient: vertical;
  }

.breadcrumbs__item--button {
    color: #707070;
  }

.breadcrumbs__divider {
    display: flex;
    align-items: center;
  }

.breadcrumbs__divider-icon {
    display: flex;
    align-items: center;
    height: 1lh;
    padding-right: calc(.25rem);
    padding-left: calc(.25rem);
    line-height: 1.375rem;
  }

.breadcrumbs__link {
    display: -webkit-box;
    height: 1lh;
    max-height: 1lh;
    overflow: hidden;
    -webkit-line-clamp: 1;
    line-height: 1.375rem;
    -webkit-box-orient: vertical;
    color: #707070;
    hyphens: auto;
    word-break: break-all;
    -webkit-text-decoration: none;
    text-decoration: none;
    hyphenate-limit-chars: 1 1 1;
  }

.breadcrumbs__link:hover {
      -webkit-text-decoration: underline;
      text-decoration: underline;
    }

.breadcrumbs__link--grow {
    flex: 1 0 auto;
  }

.breadcrumbs__link__icon {
    border-radius: 0.25rem;
  }

.breadcrumbs__link__icon:hover {
      background-color: #f6f7f8;
    }

.breadcrumbs__link__icon:active {
      background-color: #e5e6e6;
    }

.breadcrumbs__dropdown-popover {
    z-index: 110;
  }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
